/*
 * Pengelompokan kunci copy.json untuk editor dashboard.
 *
 * Daftar kuncinya TIDAK ditulis di sini — dibaca langsung dari copy.json saat
 * render. Kalau nanti ada teks baru di situs, ia otomatis muncul di dashboard
 * tanpa ada yang perlu diingat. Yang ditulis manual cuma nama manusiawi tiap
 * awalan; awalan yang belum punya nama tetap tampil, memakai awalannya sendiri.
 */
export const GROUPS = [
  { prefix: 'brand', label: 'Brand name & tagline' },
  { prefix: 'nav', label: 'Navigation & menu' },
  { prefix: 'hero', label: 'Home — hero' },
  { prefix: 'eta', label: 'Home — response time card' },
  { prefix: 'trust', label: 'Home — trust numbers' },
  { prefix: 'svc', label: 'Home — services grid' },
  { prefix: 'steps', label: 'Home — how it works' },
  { prefix: 'why', label: 'Home — why us' },
  { prefix: 'cov', label: 'Home — coverage strip' },
  { prefix: 'app', label: 'Home — mobile apps' },
  { prefix: 'faq', label: 'Home — FAQ' },
  // 'appp', bukan 'app': awalan 'app' sudah dipakai bagian mobile apps di
  // beranda. Ditambahkan belakangan bersama halaman /app, dan sempat tidak
  // punya nama kelompok sama sekali — 78 teks halaman yang sudah tayang.
  { prefix: 'appp', label: 'Page: Download the app' },
  { prefix: 'cta', label: 'Home — closing call to action' },
  { prefix: 'srec', label: 'Page: Vehicle Recovery' },
  { prefix: 'tyre', label: 'Page: Tyre Change' },
  { prefix: 'fuel', label: 'Page: Fuel Delivery' },
  { prefix: 'carservices', label: 'Page: Car Services' },
  { prefix: 'carwash', label: 'Page: Car Wash' },
  { prefix: 'cvg', label: 'Page: Coverage' },
  { prefix: 'prv', label: 'Page: Drive With Us' },
  { prefix: 'abt', label: 'Page: About' },
  { prefix: 'ct', label: 'Page: Contact' },
  { prefix: 'ch', label: 'Page: Contact — form' },
  { prefix: 'legal', label: 'Legal page headings' },
  { prefix: 'ftr', label: 'Footer' },
  { prefix: 'callbar', label: 'Sticky call bar (mobile)' }
];

/*
 * Delapan figure. /coverage TIDAK ada di sini: halaman itu memakai peta SVG,
 * bukan foto yang diunggah.
 */
export const FIGURES = [
  { slot: 'home', label: 'Home — why us' },
  { slot: 'recovery', label: 'Page: Vehicle Recovery' },
  { slot: 'tyre', label: 'Page: Tyre Change' },
  { slot: 'fuel', label: 'Page: Fuel Delivery' },
  { slot: 'carservices', label: 'Page: Car Services' },
  { slot: 'carwash', label: 'Page: Car Wash' },
  { slot: 'team', label: 'Page: About' },
  { slot: 'partner', label: 'Page: Drive With Us' }
];

// Kunci yang berisi HTML/entitas atau placeholder {var} tidak boleh diedit bebas
// tanpa peringatan: {phone}, {n} dsb diganti saat render, dan menghapusnya
// membuat kalimat kehilangan angkanya.
export const hasVars = str => /\{[a-z]+\}/i.test(str || '');
